import React, {useContext, useEffect, useState} from 'react';
import axios from 'axios';
import {Icon} from 'semantic-ui-react';

export const TeamDetailsTable = ({employee, setSelectEmployee, setSelectedEmployee, nextButtonClicked}) => {

    const [expenseStatus, setExpenseStatus] = useState(employee.expenseStatus)
    const [expenseCard, setExpenseCard] = useState(null)


    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
    const accessToken = localStorage.getItem('accessToken');
    let API = axios.create({baseURL, headers: {'Authorization': `Bearer ${accessToken}`},});
    
    async function freezeCard(event){
        const freezeExpenseCard = await API.post(`/freeze-expense-card`, {
            shipping: employee.shippingAddress,
            teamId: employee.teamId,
            id: employee.id,
            cardId: expenseCard.id
        }).catch(error => {
            console.info(error.isAxiosError && error.message); 
        });
        setExpenseStatus('freeze')
    }

    async function activateCard(event){
        const freezeExpenseCard = await API.post(`/activate-expense-card`, {
            shipping: employee.shippingAddress,
            teamId: employee.teamId,
            id: employee.id,
            cardId: expenseCard.id
        }).catch(error => {
            console.info(error.isAxiosError && error.message); 
        });
        setExpenseStatus('activateEmployee')
    }

    return (
        <tr key={employee.id} className="table-row" style={{marginTop: 20, fontStyle: 'SFProText-Medium', fontSize: 14, fontWeight: '700', backgroundColor: 'rgba(238, 241, 243, 1)'}} >
            <td>
                {employee.firstName.charAt(0).toUpperCase() + employee.firstName.slice(1) + ' ' + employee.lastName.charAt(0).toUpperCase() + employee.lastName.slice(1)}
            </td>
            <td style={{color: employee.status === 'active' ? 'green' : 'red'}}>
                {employee.status.charAt(0).toUpperCase() + employee.status.slice(1)}
            </td>
            <td>
                <span>
                    {expenseStatus === 'cardNotAssigned' ?
                        <span>No card assigned</span>
                    :
                        expenseStatus === 'activateHR' ?
                            <span>Card Not Activated by Employee</span>
                        :
                            expenseStatus === 'activateEmployee' ?
                                <span>
                                    <span style={{color: 'green'}}>Active</span>
                                </span>
                            :
                                <span>
                                    <span style={{color: 'red'}}>Inactive</span>
                                </span>
                    }
                </span>
            </td>
            <td>
                {expenseStatus === 'activateEmployee' ?
                    <span className="item" style={{padding: 0}}>
                        <button 
                            style = {{color: 'red', margin: 0}}
                            className="ui button" 
                            onClick={event => freezeCard(event)}>
                                <Icon color = 'red' name='power' />
                                Freeze Card
                        </button>
                    </span>
                :
                    expenseStatus === 'freeze' ?
                        <span className="item" >
                            <button 
                                style = {{color: 'green', margin: 0,}}
                                className="ui button" 
                                onClick={event => activateCard(event)}>
                                    <Icon color = 'green' name='power' />
                                    Activate Card
                            </button>
                        </span>
                    :
                        <span className="item" style={{height: 36}}>
                            <button disabled
                                style = {{color: 'transparent', margin: 0, backgroundColor: 'transparent'}}
                                className="ui button">
                                    {/* <Icon color = 'transparent' name='power' /> */}
                                    Activate Card
                            </button>
                        </span>
                }
            </td>
            <td><i className="angle right alternate icon"
                    style = {{color: 'grey'}}
                    onClick= {e => {
                        // setSelectEmployee(true);
                        // setSelectedEmployee(employee);
                        nextButtonClicked(employee.id)
                    }}
                    /></td>
        </tr>
    );
};